import React from "react";
import "./Header.css";
import { FaWhatsapp, FaArrowRight } from "react-icons/fa";
import { FiPhone } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
import { handleContactRedirect } from "../handleContactRedirect";

export const Header = ({ bgImage, bgVideo, text1, text2, text3, button }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const pathParts = location.pathname.split("/").filter(Boolean);

  const isLevel2 = pathParts.length === 2;
  const isLevel3OrMore = pathParts.length >= 3;
  const isHomePage = location.pathname === "/";

  return (
    <div className={`header ${!isHomePage ? "inner-header-mobile" : ""}`}>
      {/* Universal Overlay for both desktop and mobile */}
      <div className="header-overlay" />

      {isHomePage ? (
        <video
          className="header-video"
          autoPlay
          loop
          muted
          playsInline
          fetchpriority="high"
          preload="auto"
        >
          <source
            src="https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/BB%20DMC%20Website%20Video_Version%2002.mp4"
            type="video/mp4"
          />
        </video>
      ) : (
        <div
          className="header-bg-image"
          style={{
            backgroundImage: `
              linear-gradient(
                  180deg,
                  rgba(0, 31, 61, 0) 0%,
                  rgba(0, 0, 0, 0.7) 100%
                )
              , ${bgImage}`,
          }}
        />
      )}

      {/* Content */}
      <div className="header-content">
        {!isLevel3OrMore && <p className="header-text1">{text1}</p>}

        <h1
          className={`header-text2 
          ${isLevel2 ? "destination-text2" : ""} 
          ${isLevel3OrMore ? "destination-inner-text2" : ""}`}
        >
          {text2
            ?.replace(/\bwine\b/g, "Wine")
            ?.replace(/\bculture\b/g, "Culture")
            ?.replace(/\btravel\b/g, "Travel")}
        </h1>

        <p className="header-desc">{text3}</p>

        {button && (
          <div className="header-buttons">
            {isHomePage ? (
              <>
                <button
                  className="btn-outline"
                  onClick={() => (window.location.href = "tel:+971559886749")}
                >
                  <FiPhone /> Talk to Our DMC Experts
                </button>

                <button
                  className="btn-primary"
                  onClick={() =>
                    window.open(
                      "https://wa.me/+971559886749?text=Hello%20I%20have%20a%20B2B%20enquiry",
                      "_blank"
                    )
                  }
                >
                  <FaWhatsapp /> WhatsApp for B2B Enquiries
                </button>
              </>
            ) : (
              <button
                className={`btn-outline ${!isHomePage ? "btn-width" : ""}`}
                onClick={() => handleContactRedirect(navigate)}
              >
                Request Proposals <FaArrowRight />
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};